import type * as React from 'react';

import { type IconDefinition, renderIcon } from '../util';

export type DialogIconLayoutProps = { icon: IconDefinition; children: React.ReactNode };

/**
 * Render layout with icon or not.
 */
export function DialogIconLayout(props: DialogIconLayoutProps) {
    if (!props.icon) {
        return <>{props.children}</>;
    }
    return (
        <div className="-mb-6 md:-mb-10 flex">
            <div className="hidden shrink-0 pt-10 pl-10 md:flex">
                {renderIcon(props.icon, { size: 32 })}
            </div>
            <div className="md:-ml-6">{props.children}</div>
        </div>
    );
}
